import React from 'react';
import { useParams } from 'react-router-dom';

const UnsubscribeError: React.FC = () => {
  const { type } = useParams<{ type: string }>();

  const getContent = () => {
    switch (type) {
      case 'invalid':
        return {
          title: 'Invalid Link',
          message: 'This unsubscribe link is invalid or has expired. Please contact us if you need assistance.',
        };
      case 'not-found':
        return {
          title: 'Contact Not Found',
          message: 'We could not find your contact information. You may already be unsubscribed.',
        };
      case 'error':
      default:
        return {
          title: 'Error',
          message: 'An error occurred while processing your request. Please try again later or contact support.',
        };
    }
  };

  const { title, message } = getContent();

  return (
    <div className="min-h-screen bg-gray-50 flex items-center justify-center px-4">
      <div className="max-w-md w-full bg-white rounded-lg shadow-sm p-8 text-center">
        <div className="text-red-500 text-5xl mb-4">✕</div>
        <h1 className="text-2xl font-semibold text-gray-900 mb-2">{title}</h1>
        <p className="text-gray-600">{message}</p>
      </div>
    </div>
  );
};

export default UnsubscribeError;
